import { useStore } from '@/store';

export const applyAuthParamsFromUrl = () => {
  const { pathname, search, hash } = window.location;
  const params = new URLSearchParams(search);
  const userId = params.get('userId');
  const token = params.get('token');
  if (userId === null && token === null) return;

  const { setUserId, setJWT } = useStore.getState().config;
  if (userId) setUserId(userId);
  if (token) setJWT(token);

  params.delete('userId');
  params.delete('token');
  const rest = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${pathname}${rest ? `?${rest}` : ''}${hash}`,
  );
};
